module.exports = __webpack_public_path__ + "img/qui.49d1c6ad.png";